import {useEffect} from "react";

interface KpiFormulaPopoverProps {
    label: string;
    formula: string;
    value: string;
    onClose: () => void;
}

export function KpiFormulaPopover({label, formula, value, onClose}: KpiFormulaPopoverProps) {
    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") onClose();
        };
        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [onClose]);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <button
                type="button"
                className="absolute inset-0 bg-black/30"
                aria-label="Sluiten"
                onClick={onClose}
            />
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="kpi-popover-title"
                className="relative z-10 w-full max-w-md rounded-lg bg-white p-5 shadow-xl border border-gray-200"
            >
                <div className="flex items-start justify-between gap-3 mb-3">
                    <div>
                        <span className="inline-flex items-center rounded-[4px] border border-[#bfe3f8] px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-[0.04em] bg-[#EAF5FD] text-[#1E8AD1] mb-2">
                            KPI
                        </span>
                        <h3 id="kpi-popover-title" className="text-base font-semibold text-gray-900">
                            {label}
                        </h3>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="text-sm font-medium text-gray-600 hover:text-gray-900"
                    >
                        Sluiten
                    </button>
                </div>
                <div className="rounded-md bg-gray-50 border border-gray-100 p-3 mb-3">
                    <p className="text-xs font-medium text-gray-500 mb-1">Formule</p>
                    <p className="text-sm text-gray-900">{formula}</p>
                </div>
                <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-gray-500">Berekende waarde</span>
                    <span className="text-sm font-semibold text-gray-900 tabular-nums">{value}</span>
                </div>
            </div>
        </div>
    );
}
